module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_is-object.js
// module id = 24
// module chunks = 1